import React, { useEffect } from 'react';
import { get } from 'lodash';
import object from 'prop-types';
import { connect } from 'react-redux';
import { paywallWidgetImpression } from '../../../helpers/datalayer-utils';

// import DmpTracker from '../../atoms/dmp-track';
// import dmpEventsList from '../../../helpers/dmpEventsList';
import './piano-paywall.module.css';

// class HardPaywall extends React.Component {
// componentDidMount() {
// setTimeout(() => {
//   const tp = window && window.tp ? window.tp : null;
//   if (tp && tp.experience && tp.experience.execute) {
//     tp.experience.execute();
//   }
// }, 500);
//   const tp = window && window.tp ? window.tp : null;
//   if (tp && tp.experience && tp.experience.execute) {
//     tp.experience.execute();
//   }
// }
//   render() {
//     return (
//       <DmpTracker identifier="paywallDmp" eventsList={dmpEventsList}>
//         <div styleName="story-subscribe-wrap">
//           <div id="piano-hard-paywall" />
//         </div>
//       </DmpTracker>
//     );
//   }
// }

// confirm if DmpTracker needed because this will be mounted each payload everytime
// not only when paywall comes

const HardPaywall = ({ pageType }) => {
  useEffect(() => {
    // Calling the paywallWidgetImpression function for GA4 funnel
    paywallWidgetImpression(pageType);
    // window.tp.push([
    //   'addHandler',
    //   'checkoutCustomEvent',
    //   function(event) {
    //     // console.log('CTA', event);
    //     // console.log('eventDetails', event.params);
    //     switch (event.eventName) {
    //       case 'onHardpaywallSubscribe':
    //         console.log('onHardpaywallSubscribe');
    //         var dataLayerFileds = {
    //           cta_text: 'subscribe now',
    //           cta_position: 'Hard paywall',
    //           widget_type: 'article blocker widget'
    //         };
    //         // var params = JSON.parse(event.params);
    //         // page redirects to the subscription page before this callback is triggered
    //         // therefore calling the paywallCtaClick in subscriptions.js
    //         paywallCtaClick(dataLayerFileds);
    //         break;
    //       case 'onMeteredpaywallSubscribe':
    //         console.log('onMeteredpaywallSubscribe');
    //         var dataLayerFileds1 = {
    //           cta_text: 'subscribe now',
    //           cta_position: 'metered paywall',
    //           widget_type: 'article blocker widget'
    //         };
    //         // var params = JSON.parse(event.params);
    //         // page redirects to the subscription page before this callback is triggered
    //         // therefore using the paywallCtaClick in subscriptions.js
    //         paywallCtaClick(dataLayerFileds1);
    //         break;
    //     }
    //   }
    // ]);
  }, [pageType]);

  return (
    <>
      <div styleName="story-subscribe-wrap">
        <div id="piano-hard-paywall" />
      </div>
    </>
  );
};

const PianoPaywall = React.memo(HardPaywall);

HardPaywall.propTypes = {
  pageType: object
};

const mapStateToProps = state => ({
  pageType: get(state, ['qt', 'pageType'], '')
});

export default connect(mapStateToProps)(PianoPaywall);
